// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shipId: __t.u64().primaryKey().name("ship_id"),
  owner: __t.identity(),
  premiumSov: __t.i64().name("premium_sov"),
  payoutSov: __t.i64().name("payout_sov"),
  boughtAt: __t.timestamp().name("bought_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
